import { reactive, ref } from 'vue';

export function useModal(initialState: boolean = false) {
    const state = ref<boolean>(initialState);

    function open() {
        state.value = true;
    }

    function close() {
        state.value = false;
    }

    return reactive({
        state,
        open,
        close,
    });
}
